import { TIIndicatorDataModel } from "../../models/data-point/ti-indicator-data.model";
import { IndicatorType } from "../../models/enum/indicator-type.enum";
import { TIIndicatorPointToHighChartIndicatorPointMapper } from "./ti-indicator-point-to-highchart-indicator-point.mapper";

export class TIIndicatorPointToEMACloudPointMapper {
    public static mapPoints(rawData: TIIndicatorDataModel): { points: Array<any>, zones: Array<any> } {
        const firstPoints = TIIndicatorPointToHighChartIndicatorPointMapper.map(rawData, IndicatorType.EMACloud, false);
        const secondPoints = TIIndicatorPointToHighChartIndicatorPointMapper.map(rawData.childIndicators[0], IndicatorType.EMACloud, false);

        // const first = [];
        // const second = [];
        // const third = [];
        // const fourth = [];
        // const fifth = [];

        const points = [];
        const zones = [];

        for (let i = 0; i < firstPoints.points.length; i++) {
            const firstPoint = firstPoints.points[i];
            const secondPoint = secondPoints.points[i];

            // const mappedResult = TIIndicatorPointToEMACloudPointMapper.map(firstPoint.y, secondPoint.y);

            // const data1 = ObjectHelpers.copy(firstPoint);
            // data1.y = mappedResult[0]; 
            points.push([firstPoint.x, firstPoint.y, secondPoint.y]);

            const last = firstPoints.points.length - 1 == i;
            const zoneClassName = firstPoint.y < secondPoint.y ? 'zone-up-color' : 'zone-down-color';
            if (!zones.length || zones[zones.length - 1]?.className != zoneClassName) {
                zones.push({
                    value: firstPoint.x,
                    className: zoneClassName
                });
            } else if (last) {
                const lastZone = zones[zones.length - 1];
                if (lastZone) {
                    zones.push({
                        value: firstPoint.x,
                        className: lastZone.className == 'zone-up-color' ? 'zone-down-color' : 'zone-up-color'
                    });
                }
            }

            // const last = firstPoints.points.length - 1 == i;
            // if (last) {
            //     zones.push({
            //         value: firstPoint.x,
            //         className: zoneClassName
            //     });
            // }

            // const data2 = ObjectHelpers.copy(firstPoint);
            // data2.y = mappedResult[1];
            // second.push(data2);

            // const data3 = ObjectHelpers.copy(firstPoint);
            // data3.y = mappedResult[2];
            // third.push(data3);

            // const data4 = ObjectHelpers.copy(firstPoint);
            // data4.y = mappedResult[3];
            // fourth.push(data4);

            // const data5 = ObjectHelpers.copy(firstPoint);
            // data5.y = mappedResult[4];
            // fifth.push(data5);
        }

        // return [first, second, third, fourth, fifth];
        return { points: points, zones: zones };
    }

    // public static map(firstPoint: number, secondPoint: number): any {
    //     const diffFromFirstAndSecond = firstPoint - secondPoint;
    //     const thirdPoint = diffFromFirstAndSecond > 0 ? diffFromFirstAndSecond : 0;
    //     const fourthPoint = diffFromFirstAndSecond < 0 ? Math.abs(diffFromFirstAndSecond) : 0;
    //     return [firstPoint, secondPoint, thirdPoint, fourthPoint, Math.min(firstPoint, secondPoint)]
    // }
}